import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

export const useItems = (selectedCategory) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const url = selectedCategory
        ? `${domainSettings.urls.bot.items}?category=${selectedCategory.id}`
        : domainSettings.urls.bot.items;

      const response = await Utilities.fetchWithAuth(
        "GET",
        url,
        null,
        navigate,
      );

      if (response.ok) {
        setItems(response.data.results || response.data || []);
      } else {
        Utilities.showError(response, "Failed to fetch items");
      }
    } catch (error) {
      message.error("An error occurred while fetching items");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [navigate, selectedCategory]);

  const deleteItem = useCallback(
    async (itemId) => {
      try {
        const response = await Utilities.fetchWithAuth(
          "DELETE",
          domainSettings.urls.bot.itemDetail.replace(":id", itemId),
          null,
          navigate,
        );

        if (response.ok) {
          message.success("Item deleted successfully");
          fetchItems();
          return true;
        } else {
          Utilities.showError(response, "Failed to delete item");
          return false;
        }
      } catch (error) {
        message.error("An error occurred");
        console.error(error);
        return false;
      }
    },
    [navigate, fetchItems],
  );

  const filteredItems = items.filter(
    (item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.code.toLowerCase().includes(searchText.toLowerCase()),
  );

  return {
    items,
    filteredItems,
    loading,
    searchText,
    setSearchText,
    fetchItems,
    deleteItem,
  };
};
